import type { ReferencedChartTabProps } from "@wayflyer/flyui-dataviz";

import type { DashboardOutput } from "../../utils/fetch-api";
import type { CustomTimeRange } from "../../utils/types";
import { MetricTypes } from "../../autogen/metrics";
import { formatValue } from "../../strings/type-formatting";
import { includeMetricDecimal } from "../../utils/metrics";
import { getReferenceData } from "../../overview/overview-datapoints-2";
import type { SummaryPanelItemProps } from "../../components/summary-panel";

import type { TikTokAccountData } from "./tiktok-spend";

export const getGroupNameWithId = (group: string | null, accountsData: TikTokAccountData) => {
  if (accountsData && group) {
    return `${group !== "Total" ? `${accountsData[group][MetricTypes.TIKTOK_ACCOUNT_NAME]} (${group})` : group}`;
  }
  return "";
};

export const aggregateTikTokSummaryData = (
  current: DashboardOutput,
  reference: DashboardOutput,
  timeRange: CustomTimeRange,
  tabs: SummaryPanelItemProps[],
  accountsData: TikTokAccountData,
  groups: string[]
) => {
  const deriveMetric = (metricType, data) => {
    return data?.[metricType] || "";
  };

  return groups.reduce((result, group) => {
    const ts = tabs.map((tab) => {
      const metric = current.metrics.find((metric) => metric.name === tab.metricType);

      const metricValue = deriveMetric(group + tab.metricType, current.summary);
      const newTab = { tooltip: tab.tooltip, metricType: tab.metricType, title: "" };

      // Bit of a hack to make the onSelect work nicely here
      newTab["metricType"] = group;
      newTab["title"] = `${getGroupNameWithId(group, accountsData)}`;

      newTab["metricValue"] =
        metricValue == null
          ? null
          : formatValue({
              value: metricValue.toString(),
              metricType: metric,
              withDecimal: includeMetricDecimal(tab.metricType as MetricTypes),
            });
      const metricReferenceValue = deriveMetric(group + tab.metricType, reference.summary);
      newTab["metricReferenceValue"] =
        metricReferenceValue == null
          ? null
          : formatValue({
              value: metricReferenceValue.toString(),
              metricType: metric,
              withDecimal: includeMetricDecimal(tab.metricType as MetricTypes),
            });
      const referenceData = getReferenceData(metricValue, metricReferenceValue, metric?.success_direction);
      if (referenceData) {
        newTab["metricReferenceSuccess"] = referenceData.metricReferenceSuccess;
        newTab["metricReferenceDirection"] = referenceData.metricReferenceDirection;
        newTab["metricReferenceValue"] = referenceData.metricReferenceValue;
      }
      return newTab;
    });

    return [...result, ...ts];
  }, [] as ReferencedChartTabProps[]);
};
